import {draw_mouseMove, isQuoteDocuBomVisible} from "src/components/Planner/planner/planner";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import $ from 'jquery';
import {ts} from "src/utils/translate";
import {_does, uMath} from "src/components/Planner/planner/uMath";
import {GlobalsVariables, ROOT_URI} from "src/utils/constants"
import {getFrontendURL} from "src/utils/url";
import {floorProvider} from "src/components/Planner/planner/FloorProvider";
import {hideSnack, snackError, snackInfo, snackSuccess, snackWarning} from "src/utils/legacyUiAdapter";

export const ControllerGlobals = {
  /**
   * The device that the user is dragging from the tree.
   * Using CTRL-C -> CTRL-V also temporarily sets it a value.
   * @type {Product | null}
   */
  currentlyDraggedDevice: null,
}

export var IS_ON_SERVER = window.location.host.indexOf("uplan.io") !== -1;

const CAN_MODIFY_CACHE_LIFETIME = 60000; //msec
let canModifyProjectByRoomIdCache = [];
let canPutDifferentDeviceByRoomIdCache = [];

export let MC = null;
export const FADE_LENGTH = 100;
export let isMobile = false; //initiate as false
export let IS_READ_ONLY_USER = false;

export let globalNeedToSetTheScale = false;
// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
    isMobile = true;
}

export let exchangeRates = {};

export let preferredCurrency = 'eur';

export let isMouseInsideWindow = true;


export function initController() {
    MC = $('#mainContainer')
    $(document).mouseleave(function (e) {
        if (typeof e.isTrigger === "undefined") {
            isMouseInsideWindow = false;
        }
    });

    $(document).mouseenter(function (e) {
        if (typeof e.isTrigger === "undefined") {
            isMouseInsideWindow = true;
        }
    });

    $(function () {
        hidePaymentReminderIfEmpty()

        // // rightSideMenu.js dependency
        // getScriptSync('/js/app_scripts/docu-build/rightSideMenu.js');
        // createRightSideMenu();
        initToolbarEventsAndTooltips();

        $('#net-err-li').tooltip({
            trigger: 'hover',
            container: '#net-err-li'
        });

        var $feedbackSurveyModal = $('#feedback-survey-modal');

        $('#payment-reminder').click(function () {
            // openPaymentModal();
        });

        $('#license-expired-payment-btn').click(function () {
            // openPaymentModal();
        });

        $('#license-expired-cancel-btn').click(function () {
            $feedbackSurveyModal.modal({
                backdrop: "static",
                keyboard: false
            });
            $feedbackSurveyModal.modal('show');
        });

        var shouldShowBlogModal = true; // TODO GET FROM SERVER

        if (shouldShowBlogModal) {
            var $blogModalElem = $('#blog-modal');
            var closeBtn = $blogModalElem.find('.close-btn');

            $blogModalElem.on('shown.bs.modal', function () {
                toastRemoveAll();
                $('html, body').css('overflow-y', 'hidden');


                closeBtn.one('click', function () {
                    $blogModalElem.modal('hide');
                    getAuthHeader(function (headers) {
                        $.ajax({
                            headers,
                            url: ROOT_URI + '/app/seen-news-blog',
                            method: 'POST'
                        });
                    });
                });
            });

            $blogModalElem.on('hidden.bs.modal', function () {
                $('html, body').css('overflow-y', '');
            });

            $blogModalElem.modal({
                backdrop: "static",
                keyboard: false
            });
            $blogModalElem.modal('show');
        }

        getExchangeRates();
        tryNotiWarning();

        // TODO moveplannercode
        // setNotificationCount(+$('#header_notification_bar .dropdown-menu .invCount').first().html().trim());
        // TODO: moveplannercode, slimscroll dependency
        // $('.dropdown-menu-list.scroller').slimScroll({ height: 250 });
    });

    $.fn.getRealDimensions = function (outer) {
        var $this = $(this);
        if ($this.length == 0) {
            return false;
        }
        var $clone = $this.clone()
        .show()
        .css('visibility', 'hidden')
        .insertAfter($this);
        var result = {
            width: (outer) ? $clone.outerWidth() : $clone.innerWidth(),
            height: (outer) ? $clone.outerHeight() : $clone.innerHeight(),
            offsetTop: $clone.offset().top,
            offsetLeft: $clone.offset().left
        };
        $clone.remove();
        return result;
    }

    $.fn.bindFirst = function (name, fn) {
        var elem, handlers, i, _len;
        this.bind(name, fn);
        for (i = 0, _len = this.length; i < _len; i++) {
            elem = this[i];
            handlers = $._data(elem).events[name.split('.')[0]];
            handlers.unshift(handlers.pop());
        }
    };

    $(function () {
        adjustLeftSide();
    });
    $(window).on('resize', function () {
        adjustLeftSide();
    });

    $('body').append('<a href="javascript:" id="return-to-top"><i class="fa fa-arrow-up"></i></a>');

    $(window).scroll(function () {
        if ($('.quote-upper-container').length > 0 && $(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
            $('#return-to-top').fadeIn(200);    // Fade in the arrow
        } else {
            $('#return-to-top').fadeOut(200);   // Else fade out the arrow
        }
    });
    $('#return-to-top').click(function () {      // When arrow is clicked
        $('body,html').animate({
            scrollTop: 0                       // Scroll to top of body
        }, 500);
    });

    $(document).one("keydown.kch", keyChangeHandler);
    $(document).on("keyup.kch", function (e) {
        keyChangeHandler(e);
        $(document).one("keydown.kch", keyChangeHandler);
    });

    document.addEventListener("visibilitychange", handleVisibilityChange, false);

    document.addEventListener("visibilitychange", handleVisibilityChange, false);
    getExchangeRates();
    tryNotiWarning();
    // TODO moveplannercode
    // setNotificationCount(+$('#header_notification_bar .dropdown-menu .invCount').first().html().trim());
    // TODO: moveplannercode, slimscroll dependency
    // $('.dropdown-menu-list.scroller').slimScroll({ height: 250 });

    if (isMobile) {
        $(document).on('touchstart', function (e) {
            $('#device_tree, #project_tree').find('.toolong-tooltip').remove();
        });

        $('#device_tree, #project_tree').on('click', function (e) {
            if (e.target.className.indexOf("jstree-anchor") !== -1) {
                showTooLongTooltipForEvent(e);
            }
        }).on('scroll', function (e) {
            $(this).find('.toolong-tooltip').remove();
        });
    }
    else {
        $('#device_tree, #project_tree').on('mouseover', function (e) {
            if (e.target.className.indexOf("jstree-anchor") !== -1 && e.originalEvent) {
                showTooLongTooltipForEvent(e);
            }
        }).on('mouseout', function (e) {
            if (e.target.className.indexOf("jstree-anchor") !== -1) {
                $(e.target).tooltip('hide');
            }
        }).on('scroll', function () {
            $(this).find('.toolong-tooltip').remove();
        });
    }

    MC.on('mouseenter', function (e) {
        if (ControllerGlobals.currentlyDraggedDevice) {
            var openProjectId = isQuoteDocuBomVisible();
            if (openProjectId) {
                var floorIdToOpen = null;

                var potentialFloorElems = $('[data-floorid]:visible');

                if (potentialFloorElems.length) {
                    var mousePt = { x: e.clientX, y: e.clientY };
                    var minDist = -1;
                    var minElem = -1;

                    for (let i = 0; i < potentialFloorElems.length; i++) {
                        var elem = potentialFloorElems[i];
                        if (typeof elem.getBoundingClientRect === "function") {
                            var rect = elem.getBoundingClientRect();
                            if (rect.width > 0 && rect.height > 0) {
                                var topLeft = { x: rect.x, y: rect.y };
                                var bottomLeft = { x: rect.x, y: rect.y + rect.height };
                                var dist = uMath.pointSegmentDistance(mousePt, topLeft, bottomLeft);
                                if (minElem === -1 || dist < minDist) {
                                    minDist = dist;
                                    minElem = elem;
                                }
                            }
                        }
                    }

                    if (minElem !== -1) {
                        console.debug('found relevant close floor element');
                        floorIdToOpen = $(minElem).attr('data-floorid');
                    }
                }

                if (!floorIdToOpen) {
                    console.debug('fallback to first floor');
                    floorIdToOpen = floorProvider.getFirstFloorId();
                }

                if (floorIdToOpen) {
                    var floorNodeId = 'floor_' + floorIdToOpen;
                  // TODO: moveplannercode-deadcode
                  //   var node = ProjectTreeGlobals.projectTree.get_node(floorNodeId);
                  //   if (node) {
                  //       ProjectTreeGlobals.projectTree.activate_node(floorNodeId);
                  //       ProjectTreeGlobals.previousNode = node;
                  //       openFloor(floorIdToOpen);
                  //   }
                }
            }
        }
    });

}

/**
 *
 * @param {JQuery.Deferred<any,any,any>[]} promiseArr
 * @returns {JQuery.Promise<any,never,never>}
 */
export function whenAll(promiseArr) {
    return $.when.apply($, promiseArr);
}


export var ffc = -1;


export function logDebug(msg) {
    if (GlobalsVariables.env === "dev") {
        console.debug(msg);
    }
}


export function getAuthHeader(callback) {
    const key = localStorage.getItem("authkey");
    if (key === null) {
        $.ajax({
            url: getFrontendURL() + '/site/get-auth-token',
            type: 'GET',
            dataType: 'JSON',
            success: function (response) {
                const token = response.token;
                const header = { "Authorization": "Bearer " + token};
                localStorage.setItem("authkey", token);
                callback(header);
            },
            error: function (response) {
                if (response.responseJSON && response.responseJSON.message) {
                    toastError(response.responseJSON.message);
                }
            }
        });
    } else {
        const header = { "Authorization": "Bearer " + key};
        callback(header);
    }
}

export let FULL_SCREEN_ON_ICON = "fa fa-arrows-alt";
export let FULL_SCREEN_OFF_ICON = "fa fa-compress rotate90";

export function getAuthHeaderSync() {
    var header;
    const key = localStorage.getItem("authkey");

    if (key === null) {
        $.ajax({
            url: getFrontendURL() + '/site/get-auth-token',
            type: 'GET',
            dataType: 'JSON',
            async: false,
            success: function (response) {
                const token = response.token;
                header = { "Authorization": "Bearer " + token};
                localStorage.setItem("authkey", token);
            },
            error: function (response) {
                if (response.responseJSON && response.responseJSON.message) {
                    toastError(response.responseJSON.message);
                }
            }
        });
    } else {
        header = { "Authorization": "Bearer " + key};
    }
    return header;
}

export function putProgressBar() {
    if (isThereProgressBar()) { return; }
    var listElem = $('<li style="pointer-events: none;" class="loader-cog" id="uplan-main-progress"><a style="display: flex;"></a></li>');
    var textContainer = $('<div style="margin-right: 10px;" id="uplan-progress-text"></div>');
    var outer = $('<div class="progress" style="width: 150px; margin-bottom: 0;"></div>');
    var bar = $('<div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%">');
    var text = $('<span class="progresstext">0%</span>');
    bar.append(text);
    outer.append(bar);
    listElem.find('a').append(textContainer);
    listElem.find('a').append(outer);
    $('.navbar-nav').prepend(listElem);

}

export function removeProgressBar() {
    $('#uplan-main-progress').remove();
}

export function isThereProgressBar() {
    return !!$('#uplan-main-progress').length;
}

/**
 *
 * @param {number} state between 0 and 100
 */
export function setProgressBarState(state) {
    if (!$.isNumeric(state)) {
        return;
    }
    state = Math.round(uMath.clamp(state, 0, 100));
    if (!isThereProgressBar()) {
        putProgressBar();
    }
    var elem = $('#uplan-main-progress');

    var text = elem.find(".progresstext");
    text.text(state + "%");
    var bar = elem.find('.progress-bar');
    bar.attr('aria-valuenow', state);
    bar.css('width', state + '%');
    if (state < 16) {
        text.hide();
    }
    else {
        text.show();
    }
}

export function setProgressBarStatus(statusMsg) {
    if (!isThereProgressBar()) {
        putProgressBar();
    }
    if (!statusMsg) { statusMsg = ""; }
    $('#uplan-progress-text').text(statusMsg);
}

export function startLoading() {
    stopLoading();
    $('.navbar-nav').prepend('<li class="loader-cog"><a><i class="fa fa-cog"></i></a></li>');
}

export function stopLoading() {
    $('.navbar-nav').find('.loader-cog').remove();
    removeProgressBar();
}

export function areToastsDisabled() {
    return $('#blog-modal').is(':visible');
}

export function toastErrorEnglish(text) {
    if (areToastsDisabled()) {
        return false;
    }
    snackError(text);
}

export function toastErrorSingle(text, sticky = false, withClass = "") {
    toastError(text, sticky, withClass);
}

export function toastInfoSingle(text, sticky = false, withClass = "") {
    toastInfo(text, sticky, withClass);
}

export function toastInfoImportantSingle(text, sticky = false, withClass = "") {
    toastInfoImportant(text, sticky, withClass);
}

export function toastError(text, sticky = false, withClass = "") {
    if (areToastsDisabled()) {
        return false;
    }
    snackError(text);
}
export function toastSuccess(text, sticky = false, withClass = "") {
    if (areToastsDisabled()) {
        return false;
    }
    snackSuccess(text);
}

export function toastInfo(text, sticky = false, withClass = "") {
    if (areToastsDisabled()) {
        return false;
    }
    snackInfo(text);
}

export function toastInfoImportant(text, sticky = false, withClass = "") {
    if (areToastsDisabled()) {
        return false;
    }
    snackWarning(text);
}

export function toastNotProError(textOverride) {
    if (areToastsDisabled()) {
        return false;
    }
    snackError(textOverride || ts('toast_not_pro', "You cannot use this feature because you don't have a valid pro license, <b>click here</b> to get a subscription."));
}


export function toastNotPro(textOverride) {
    if (areToastsDisabled()) {
        return false;
    }
    snackInfo(textOverride || ts('toast_not_pro',
        "You cannot use this feature because you don't have a valid pro license, <b>click here</b> to get a subscription."));
}

export function toastRemoveAll() {
    hideSnack();
}

export function toastRemoveClass(classNames) {
    hideSnack();
}

export let plannerOpenedDeferred;


export function adjustLeftSide() {
    var neededHeight = window.innerHeight - 50 - 20;
    $('#page-left-portal').css('max-height', neededHeight);
    neededHeight /= 2;
    if (document.querySelector('#page-left-portal .btn')) {
        neededHeight -= 18;
    }
    $('#projectsPortlet, #devicesPortlet').height(neededHeight);
}

export function noLangErrMsg() {
    toastErrorEnglish('Something went wrong while trying to get language data');
}

export function genericXHRErrorHandler(response, silent = false) {
    stopLoading();
    if (!response) {
        return;
    }
    var toReturn = "";
    var resp = response.responseJSON && response.responseJSON.message || response.responseText;
    var isNotProMsg = response.responseJSON && response.responseJSON.code == 440;

    if (resp) {
        if (isNotProMsg && !silent) {
            toastNotPro(resp);
        }
        else {
            try {
                var parsed = JSON.parse(resp);
                if (typeof parsed === "object" && "message" in parsed) {
                    parsed = parsed.message;
                }
                var errStrings = "";
                if (typeof parsed === "object") {
                    for (var i in parsed) {
                        errStrings += parsed[i] + '<br>';
                    }
                }
                else {
                    errStrings = parsed;
                }
                if (!silent) {
                    toastError(errStrings);
                }
                toReturn = errStrings;
            }
            catch (e) {
                if (!silent) {
                    toastError(resp);
                }
                toReturn = resp;
            }
        }
    }

    return toReturn;
}

export function initToolbarEventsAndTooltips() {
    $('.dropdown, .page-header .dropdown-toggle').tooltip({
        trigger: 'hover',
        container: '.top-menu',
        placement: 'bottom'
    });
    // // righsidemenu dependency
    // $('#rightside-toggler').off('click.trsm').on('click.trsm', () => typeof toggleRightSideMenu === "function" && toggleRightSideMenu());
}


export function tryNotiWarning() {
    var NOTI_CRITICAL = 5;
    var NOTI_WARNINGS = 3;

    var cached = localStorage.getItem("notiCachedProps");
    var cachedJSON = null;
    if (cached) {
        cachedJSON = JSON.parse(cached);
    }

    var noti = {
        notis: +$('#invCount').html(),
        date: +new Date(),
        notifiedCount: cachedJSON ? cachedJSON.notifiedCount : 0
    };

    //remind user if hasn't ever been reminded, or current notification count is bigger than at last refresh
    if (!cachedJSON && noti.notis > 0 || cachedJSON && cachedJSON.notis < noti.notis) {
        if (noti.notifiedCount < NOTI_WARNINGS) {
            noti.notifiedCount++;
            //toastShowNoti();
        }
    } else if (noti.notis >= NOTI_CRITICAL) {
        noti.notifiedCount++;
        //toastShowNoti();
    }

    localStorage.setItem("notiCachedProps", JSON.stringify(noti));
}

export function getTextFromHtmlString(htmlStr) {
    return $('<span>' + htmlStr + '</span>').text().trim();
}

export let MODKEYS_STATE = {
    shift: false,
    alt: false,
    ctrl: false,
    meta: false,
}

export function keyChangeHandler(e) {
    MODKEYS_STATE.shift = e.shiftKey;
    MODKEYS_STATE.alt = e.altKey;
    MODKEYS_STATE.ctrl = e.ctrlKey;
    MODKEYS_STATE.meta = e.metaKey;
    if (typeof PlannerGlobals.isDrawing != 'undefined' && PlannerGlobals.isDrawing) {
        draw_mouseMove();
    }
}

export function handleVisibilityChange(e) {
    MODKEYS_STATE = {
        shift: false,
        alt: false,
        ctrl: false,
        meta: false,
    }
    if (!document.hidden) {
        $(document).off("keydown.kch");
        $(document).one("keydown.kch", keyChangeHandler);
    }
}

let exRateFetched = false;

export function printTimeTaken(measureName) {
    console.log('calculated in ' + Math.round(performance.getEntriesByName(measureName)[0].duration) + 'ms');
}

export let supportedCurrencies = ['eur', 'huf', 'gbp', 'czk', 'usd', 'pln', 'chf'];

export function getExchangeRates() {
    if (!exRateFetched) {
        exRateFetched = true;
        getAuthHeader(function (header) {
            $.ajax({
                headers: header,
                url: ROOT_URI + '/quote/exchange-rates',
                success: function (resp) {
                    var othersThanHuf = supportedCurrencies.filter(function (curr) { return curr !== "huf"; });
                    exchangeRates = {};
                    for (let currency of supportedCurrencies) {
                        exchangeRates[currency] = {};
                    }
                    for (let currency of othersThanHuf) {
                        var currHuf = +resp[currency + "-huf"];
                        exchangeRates[currency]['huf'] = currHuf;
                        exchangeRates['huf'][currency] = 1 / currHuf;
                    }
                    for (let p1 = 0; p1 < othersThanHuf.length - 1; p1++) {
                        for (let p2 = p1 + 1; p2 < othersThanHuf.length; p2++) {
                            var curr1 = othersThanHuf[p1];
                            var curr2 = othersThanHuf[p2];
                            var curr1Huf = exchangeRates[curr1]['huf'];
                            var curr2Huf = exchangeRates[curr2]['huf'];
                            exchangeRates[curr1][curr2] = curr1Huf / curr2Huf;
                            exchangeRates[curr2][curr1] = curr2Huf / curr1Huf;
                        }
                    }
                    exRateFetched = true;
                },
                error: function (resp) {
                    exRateFetched = false;
                    if (resp.responseJSON && resp.responseJSON.message) {
                        toastError(resp.responseJSON.message);
                    }
                }
            });
        });
    }
}

export function showTooLongTooltipForEvent(e) {
    var isOutRight = e.target.scrollWidth > e.target.offsetWidth;
    if (isOutRight) {
        var innerStyle = "max-width: 800px; padding: 2px 4px; background: #3c3c3c; color: #ececec;"
        var elem = $(e.target);
        elem.tooltip({
            trigger: 'manual',
            title: e.target.innerText.trim(),
            viewport: '#' + e.currentTarget.id,
            placement: 'top',
            template: '<div class="tooltip tooltip-force-left toolong-tooltip" role="tooltip" style="opacity:1; pointer-events: none;"><div class="tooltip-inner midshadow" style="' + innerStyle + '"></div></div>'
        });
        $('.toolong-tooltip').remove();
        elem.tooltip('show');
    }
}

/**
 *
 * @template T
 * @param {T} obj
 * @returns {T}
 */
export function deepCopy(obj) {
    var src = Array.isArray(obj) ? [] : {};
    return $.extend(true, src, obj);
}


export function hidePaymentReminderIfEmpty() {
    var reminder = $('#payment-reminder');
    var text = reminder.text().trim();
    if (text.length === 0) {
        reminder.hide();
    }
}

export function canModifyProjectByProjectId(projectId) {
    var header = getAuthHeaderSync();
    var result = false;
    $.ajax({
        async: false,
        headers: header,
        url: ROOT_URI + '/project/can-modify-project-by-project-id?project_id='+projectId,
        success: function (resp) {
            result = resp;
        }
    });
    return result;
}

export function canModifyProjectByRoomId(roomId) {
    var header = getAuthHeaderSync();
    var result = false;
    var d = new Date();
    if(canModifyProjectByRoomIdCache[roomId] !== undefined)
    {
        if((canModifyProjectByRoomIdCache[roomId]['checked'] + CAN_MODIFY_CACHE_LIFETIME) > d.getTime())
            return canModifyProjectByRoomIdCache[roomId]['response'];
    }
    $.ajax({
        async: false,
        headers: header,
        url: ROOT_URI + '/project/can-modify-project-by-room-id?room_id='+roomId,
        success: function (resp) {
            result = resp;
            canModifyProjectByRoomIdCache[roomId] = [];
            canModifyProjectByRoomIdCache[roomId]['checked'] = d.getTime();
            canModifyProjectByRoomIdCache[roomId]['response'] = resp;

        }
    });
    return result;
}

export function canPutDifferentDeviceByRoomId(roomId, productId, numericalProductId)
{
    var header = getAuthHeaderSync();
    var result = false;
    var d = new Date();
    if(canPutDifferentDeviceByRoomIdCache[roomId] !== undefined && canPutDifferentDeviceByRoomIdCache[roomId][numericalProductId] !== undefined) {
        if((canPutDifferentDeviceByRoomIdCache[roomId][numericalProductId]['checked'] + CAN_MODIFY_CACHE_LIFETIME) > d.getTime()) {
            return canPutDifferentDeviceByRoomIdCache[roomId][numericalProductId]['response'];
        }
    }
    $.ajax({
        async: false,
        headers: header,
        url: ROOT_URI + '/project/can-put-different-device-by-room-id?room_id='+roomId+'&product_id='+productId+'&project_id='+PlannerGlobals.plannerProjectId,
        success: function (resp) {
            result = resp;
            // cache only if response is true, otherwise device will not added to room and cannot be removed from cache
            if(resp) {
                if (canPutDifferentDeviceByRoomIdCache[roomId] === undefined) {
                    canPutDifferentDeviceByRoomIdCache[roomId] = [];
                }
                canPutDifferentDeviceByRoomIdCache[roomId][numericalProductId] = [];
                canPutDifferentDeviceByRoomIdCache[roomId][numericalProductId]['checked'] = d.getTime();
                canPutDifferentDeviceByRoomIdCache[roomId][numericalProductId]['response'] = resp;
            }

        }
    });
    return result;
}

export function removeDeviceFromCanPutDifferentDeviceByRoomIdCache(roomId, numericalProductId) {
    if (canPutDifferentDeviceByRoomIdCache[roomId] && canPutDifferentDeviceByRoomIdCache[roomId][numericalProductId]) {
        delete canPutDifferentDeviceByRoomIdCache[roomId][numericalProductId];
        if (Object.keys(canPutDifferentDeviceByRoomIdCache[roomId]).length === 0) {
            delete canPutDifferentDeviceByRoomIdCache[roomId];
        }
    }
}



export function getMeasurementSystem(projectId) {
    return new Promise((res, rej) => {
        const validNames = ["metric", "imperial"];
        $.ajax({
            url: ROOT_URI + '/project/get-measurement-system',
            method: 'POST',
            data: {
                project_id: +projectId,
            },
            headers: getAuthHeaderSync(),
            success: resp => {
                if (resp && typeof resp === "object" && 'system_name' in resp && typeof resp.system_name === "string") {
                    const systemNameLowCase = resp.system_name.toLowerCase();
                    if (_does(validNames).contain(systemNameLowCase)) {
                        return res(systemNameLowCase);
                    }
                    else {
                        return res("metric");
                    }
                }
            },
            error: resp => {
                genericXHRErrorHandler(resp);
                return res("metric"); // using metric as default if error occurs
            }
        });
    });
}
